import { useSelector } from "react-redux";
import markupService from "../../services/MarkupService/markupService";
import arMarkupService from "../../services/MarkupService/arMarkupService";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { ENABLED } from "../../constants/Constants";
import useLanguageChange from "../../hooks/useLanguageChange";

const SaveButton = () => {
    const localisedValues = useLanguageChange();
    const { savebtndisabled, allShapeDisable, annPointlength } = useSelector((state) => state.markup);

    const saveMarkup = () => {
        markupService.toggleannotationdiv(false, true, false);
    };

    return (
        <>
            {((arMarkupService.checkARMarkupIsOngoing() && PublicVariables.featureFlag?.SAVEARMARKUPIMAGE == ENABLED) ||
                (!arMarkupService.checkARMarkupIsOngoing() && PublicVariables.featureFlag?.SHOWMESAVEMARKUP == ENABLED)) &&
                GLOBAL_MEETING_DATA.isAgent && (
                    <div className='markup-menu-item mob-markup-menu-item markup-menu-item-save'>
                        <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                            <button
                                className='btn markup-menu-btn'
                                id='save-markup-button'
                                disabled={!annPointlength || savebtndisabled || allShapeDisable}
                                onClick={() => saveMarkup()}
                            >
                                <span className='btn-icon icon-save'></span>
                                <span className='mob-btn-text'>{localisedValues?.save}</span>
                            </button>
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues?.save}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>
    );
};

export default SaveButton;
